<div class="title-bar">
  <div class="title">
    <span class="text"
      ><h2>{{ title | translate | titlecase }}</h2></span
    >
  </div>
  <div>
    <img class="logo" src="../../assets/images/BFHLogo.png" />
  </div>
</div>
